import './ArtemSpinner.css'
import cx from 'classnames'

export function ArtemSpinner({ className }: { className?: string }) {
  return (
    <svg
      version="1.2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 150 149"
      className={cx('artem-spinner-svg', className)}
    >
      <g id="Gruppe_88">
        <g id="Gruppe_maskieren_89">
          <g id="Gruppe_87">
            <g id="Gruppe_75">
              <path
                fill="#02FFD8"
                id="Pfad_32"
                d="m43.08 63.57h-42.08v22h45.27c9.86 0 17.86 8 17.86 17.86v45.27h22v-42.08c0-2.26-0.9-4.42-2.5-6.02l-34.53-34.53c-1.6-1.6-3.77-2.5-6.02-2.5z"
              />
              <path
                fill="#02FFD8"
                id="Pfad_55"
                d="m107.62 85.13h42.08v-22h-45.27c-9.86 0-17.86-7.99-17.86-17.85v-45.28h-22v42.08c0 2.26 0.9 4.43 2.5 6.02l34.53 34.53c1.6 1.6 3.76 2.5 6.02 2.5z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
